import { render, staticRenderFns } from "./EmailMessageInfo.vue?vue&type=template&id=2fc6aec3&scoped=true"
import script from "./EmailMessageInfo.vue?vue&type=script&lang=js"
export * from "./EmailMessageInfo.vue?vue&type=script&lang=js"
import style0 from "./EmailMessageInfo.vue?vue&type=style&index=0&id=2fc6aec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc6aec3",
  null
  
)

export default component.exports